'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'earth-americas';
var width = 512;
var height = 512;
var aliases = [127758,"earth","earth-america","globe-americas"];
var unicode = 'f57d';
var svgPathData = 'M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464zM410.4 255.3L393.5 204.6C388.2 188.6 396.3 171.1 412 164.8L464 144L480 288L433 276.3C422.4 273.6 413.9 265.7 410.4 255.3L410.4 255.3zM67.07 209.4L48 176L64 128L144 48L248 16L268.8 52.42C275.5 64.16 274.1 78.85 265.3 89.12L249.6 107.5C239.4 119.3 239.3 136.8 249.3 148.8L262.9 165C268.3 171.5 268.8 180.8 264.1 187.9C259.3 195 250.3 198.1 242.2 195.4L218.1 187.7C211.9 185.3 204.3 185.9 197.7 189.2L191.7 192.1C182.7 196.7 178.4 207.1 181.6 216.7C183.1 221.4 186.4 225.4 190.7 227.8L225.2 247.6C234.9 253.1 245.9 255.1 256.1 255.1H300.1C312.8 255.1 325.1 261.1 334.1 270.1L337.9 273.9C346.9 282.9 352 295.2 352 307.9V316.1C352 333.4 342.8 349.3 327.8 357.8L318.6 363.1C304.1 371.4 293.4 384.1 288.8 401.1L287.3 406.5C282.8 422.3 270.3 434.8 254.5 439.3C239.2 443.7 223.1 432.2 223.1 416.3V385.9C223.1 374.9 217.8 364.9 207.1 360C198.2 355.1 191.1 345.1 191.1 334.1V294.2C191.1 276.3 180.2 260.6 162.1 255.7L105.1 239.2C88.99 234.6 75.36 223.9 67.07 209.4L67.07 209.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEarthAmericas = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;